import React from 'react';
import { Grid } from '@mui/material';
import InsertAction from "./InsertAction";
import Calendar from "./Calendar";
import HelpGuideDialog from './HelpGuideDialog';

// Questo componente definisce il contenuto della pagina principale del dashboard
const MainDashboardPage = ({ admin }) => {
    return (
        <Grid container spacing={3}>
            {/* Colonna sinistra per il form di inserimento */}
            <Grid item xs={12} md={8} lg={9}>
                <HelpGuideDialog isAdmin={admin} />
                <InsertAction admin={admin} />
            </Grid>
            {/* Colonna destra per il calendario */}
            <Grid item xs={12} md={4} lg={3}>
                <Calendar admin={admin} />
            </Grid>
        </Grid>
    );
};

export default MainDashboardPage;